import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { getAllCloseDeal } from "../../../services/dashboard-service/closingDealsService";

// const closingDeals = [
//   {
//     id: 1,
//     dealName: "Acme Inc Install",
//     salesRep: "Donald Risher",
//     amount: "96",
//     closeDate: "Today",
//   },
//   {
//     id: 2,
//     dealName: "Save lots Stores",
//     salesRep: "Jansh Brown",
//     amount: "55.7",
//     closeDate: "30 Dec 2021",
//   },
//   {
//     id: 3,
//     dealName: "William PVT",
//     salesRep: "Ayaan Hudda",
//     amount: "102",
//     closeDate: "25 Nov 2021",
//   },
//   {
//     id: 4,
//     dealName: "Raitech Soft",
//     salesRep: "Julia William",
//     amount: "89.5",
//     closeDate: "20 Sep 2021",
//   },
//   {
//     id: 5,
//     dealName: "Absternet LLC",
//     salesRep: "Vitoria Rodrigues",
//     amount: "89.5",
//     closeDate: "20 Sep 2021",
//   },
// ];

const styleCard ={
    borderRadius: '1rem'
}

const ClosingDeals = () => {
  const [closingDeals, setClosingDeals] = useState([]);

  const getCloseDealData = async() => {
    const closeDealData = await getAllCloseDeal();
    setClosingDeals(closeDealData)
  }

  useEffect(()=>{
    getCloseDealData();
  },[])

  return (
    <>
      <Card style={styleCard}>
        <CardBody>
          <div style={{display:'flex', marginBottom:'1vh'}}>
            <h4 className="card-title mb-0 flex-grow-1">Closing Deals</h4>
            <div className="flex-shrink-0">
              <select className="form-select form-select-sm">
                <option defaultValue="">Closed Deals</option>
                <option value="1">Active Deals</option>
                <option value="2">Paused Deals</option>
                <option value="3">Canceled Deals</option>
              </select>
            </div>
          </div>
          {/* <div className="table-responsive">
            <table className="table table-bordered table-nowrap align-middle mb-0">
              <thead>
                <tr>
                  <th scope="col" style={{ width: "30%" }}>
                    Customer Name
                  </th>
                  <th scope="col" style={{ width: "30%" }}>
                    Lead by
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                    Industry
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                    Close Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {(closingDeals || []).map((item, key) => (
                  <tr key={key}>
                    <td>{item.name}</td>
                    <td>
                      <Link to="#" className="text-body fw-medium">
                        {item.assignedUser}
                      </Link>
                    </td>
                    <td>{item.industry}</td>
                    <td>{item?.updatedAt.split('T')[0]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div> */}
          <div className="table-responsive">
              <table className="table table-bordered table-nowrap align-middle mb-0">
                <thead>
                  <tr>
                    <th scope="col" style={{ width: "30%" }}>
                      Customer Name
                    </th>
                    <th scope="col" style={{ width: "30%" }}>
                      Lead by
                    </th>
                    <th scope="col" style={{ width: "20%" }}>
                      Industry
                    </th>
                    <th scope="col" style={{ width: "20%" }}>
                      Close Date
                    </th>
                  </tr>
                </thead>
              </table>
              <div
                style={{
                  maxHeight: "35vh", // Adjust height as needed
                  overflowY: "auto",
                }}
              >
                <table className="table table-bordered table-nowrap align-middle mb-0">
                  <tbody>
                    {(closingDeals || []).map((item, key) => (
                      <tr key={key}>
                        <td style={{ width: "30%" }}>{item.name}</td>
                        <td style={{ width: "30%" }}>
                          <Link to="#" className="text-body fw-medium">
                            {item.assignedUser}
                          </Link>
                        </td>
                        <td style={{ width: "20%" }}>{item.type}</td>
                        <td style={{ width: "20%" }}>{item?.updatedAt.split('T')[0]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
        </CardBody>
      </Card>
    </>
  );
};

export default ClosingDeals;
